import DashboardClinicalPassport from "./DashboardClinicalPassport";

export default DashboardClinicalPassport;